"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const filesize_1 = __importDefault(require("filesize"));

const link_helpers_1 = require("./link_helpers");

function humanizeDuration(duration) {
  const hoursNum = Math.floor(duration / 3600);
  const minutesNum = Math.floor(duration % 3600 / 60);
  const secondsNum = duration % 60;
  const hoursStr = hoursNum < 10 ? `0${hoursNum}` : hoursNum;
  const minutesStr = minutesNum < 10 ? `0${minutesNum}` : minutesNum;
  const secondsStr = secondsNum < 10 ? `0${secondsNum}` : secondsNum;
  return hoursNum > 0 ? [hoursStr, minutesStr, secondsStr].join(':') : [minutesStr, secondsStr].join(':');
}

function makeDescription(link) {
  let desc = '';

  if (link_helpers_1.isFile(link)) {
    const size = link.size;
    const prettySize = filesize_1.default(size || 0, {
      round: 0
    });
    const extension = link.extension;
    desc = `${prettySize} ${extension} file`;
  } else if (link_helpers_1.isStatic(link)) {
    if (link_helpers_1.isAudio(link) || link_helpers_1.isVideo(link)) {
      // @ts-ignore
      if (link.metadata && link.metadata.duration) {
        // @ts-ignore
        const duration = humanizeDuration(link.metadata.duration);

        if (link_helpers_1.isAudio(link)) {
          desc = `${duration} audio`;
        } else {
          desc = `${duration} video`;
        }
      }
    } else if (link_helpers_1.isDocument(link)) {
      if (link_helpers_1.isCode(link)) {
        const codeType = (link.extension || '').toUpperCase();
        desc = `${codeType} code`;
      } else if (link_helpers_1.isPdf(link)) {
        desc = 'PDF document';
      } else if (link_helpers_1.isWordDocument(link)) {
        desc = 'Word document';
      } else if (link_helpers_1.isPowerpointPresentation(link)) {
        desc = 'Powerpoint presentation';
      } else if (link_helpers_1.isExcelSpreadsheet(link)) {
        desc = 'Excel spreadsheet';
      } else {
        const docType = (link.extension || '').toUpperCase();
        desc = `${docType} document`;
      }
    }
  } else if (link.description) {
    desc = link.description;
  } else if (link.authors && link.authors[0] && link.authors[0].name) {
    desc = `by ${link.authors[0].name}`;
  }

  return desc;
}

exports.default = makeDescription;